export const creditCardLimitChange = {
    showRemainingAmountInsteadOfSpentAmount: true,
};
